import {
  DeprecatedTaskTypes,
  type TaskTypeAll,
  TaskTypes,
} from 'services/tasks/types';
import type {OverviewTaskType} from '../types';

export const getTaskTypes = (
  selectedTaskType: TaskTypeAll,
): OverviewTaskType[] =>
  TaskTypes.filter(t => !DeprecatedTaskTypes.includes(t)).map(task => ({
    task,
    checked: task === selectedTaskType,
  }));
